// extracted by mini-css-extract-plugin
module.exports = {"shadowed":"BaseLayout_shadowed__xZ46-","dark":"BaseLayout_dark__3JoGj","light":"BaseLayout_light__tbwgN"};